module.exports = __webpack_public_path__ + "static/media/logo-crt-fr-inline.6db93f5a.png";